import {DYNAMIC_COMPONENT_SAVE_DATA} from 'common/types';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {call, take, select, fork, put} from 'redux-saga/effects';
import _ from 'lodash';
import ConcurrentEditProcessor from 'framework/classes/concurrentEditProcessor';
import {isRoomManagedPath} from 'common/storeUtils';
import {BREAKPOINTS, debugBreakpoint} from 'common/debug';
import CollaborationActions from 'go/actions/api/collaboration';

export default function* dynamicSaveSaga() {
  yield take(DYNAMIC_COMPONENT_SAVE_DATA);
  yield fork(saveFromReduxStateToService);
  yield put(DynamicComponentActions.validateConfigRules());
  yield call(dynamicSaveSaga);
}

export function* saveFromReduxStateToService() {
  const state = yield select();
  const action = {
    type: DYNAMIC_COMPONENT_SAVE_DATA,
    storePath: 'data',
    collaborationStorePath: 'data',
  };
  debugBreakpoint(BREAKPOINTS.collaborationLocalSync);
  if (isRoomManagedPath(state, action)) {
    yield put(
      CollaborationActions.localUpdated({
        ...action,
        collaborationSaveType: action.type,
      })
    );
    return;
  }
  if (!_.isEqual(state.dynamicComponent.data, state.dynamicComponent.dataCopy)) {
    const payload = {data: state.dynamicComponent.data};
    if (typeof state.dynamicComponent.serviceCall === 'object') {
      yield put(DynamicComponentActions.cleanData());
      yield call(() =>
        ConcurrentEditProcessor.next({
          entityType: 'data',
          entityId: payload.data.entityId,
          from: 'dynamicSaveSaga',
        })
      );
    } else if (state.dynamicComponent.serviceCall) {
      yield put(
        state.dynamicComponent
          .serviceCall(payload, state.auth.token)
          .then((res) => {
            return DynamicComponentActions.cleanData();
          })
          .catch((err) => {
            return console.error('error in dynamicSaveSaga: ');
          })
      );
    }
  }
}
